import dropThirdPartyEvents from './dropThirdPartyEvents'

export default dropThirdPartyEvents
